// 本地存储操
// 获取数据
const getItem = name => {
  const data = window.localStorage.getItem(name)
  try {
    return JSON.parse(data)
  } catch (err) {
    return data
  }
}

// 存储数据
const setItem = (name, value) => {
  if (typeof value === 'object') {
    value = JSON.stringify(value)
  }
  window.localStorage.setItem(name, value)
}

// 删除数据
const removeItem = name => {
  window.localStorage.removeItem(name)
}

export { getItem, setItem, removeItem }
